import morphism, { StrictSchema } from 'morphism'
import { MiddlewareAPI, Dispatch, Action } from 'redux'

import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import ServerUploadedPassengerInterface from '../../interfaces/server/UploadedPassenger'

import uploadedPassengerToPassengerSchema from '../../schemas/client/uploadedPassengerToPassenger'

import { addNotification } from '../../actions/notifications'
import { addUploadedPassengers } from '../../actions/passengers'
import { UPLOAD_PASSENGERS } from '../../actions/passengers/uploadPassengers'

import {
  getSmallestEconomyClassAllotmentCountFactory,
  getSmallestSmartClassAllotmentCountFactory,
} from '../../utils/travelClassSeatCount'
import { buildGenericNotification } from '../../utils/notifications'
import getLabels from '../../utils/getLabels'
import sortArray from '../../utils/sortArray'

export interface UploadPassengersAction extends Action {
  passengers: ServerUploadedPassengerInterface[]
  selectedFlightIds: string
}

export default (store: MiddlewareAPI) => (next: Dispatch) => async (
  action: UploadPassengersAction
) => {
  next(action)

  if (action.type !== UPLOAD_PASSENGERS) return

  const dispatch = store.dispatch

  // Check too many rows in the CSV
  const state: ReduxStoreInterface = store.getState()
  const amountOfUploadedPassengers = action.passengers.length
  const activeFlightIds = state.flights.allIds.filter((flightId: string) =>
    action.selectedFlightIds.includes(flightId)
  )
  const departureFlight = state.flights.byId[activeFlightIds[0]]
  const returnFlight = state.flights.byId[activeFlightIds[1]]

  const economyClassAllotment =
    getSmallestEconomyClassAllotmentCountFactory(
      departureFlight,
      returnFlight
    ) || 0
  const smartClassAllotment =
    getSmallestSmartClassAllotmentCountFactory(departureFlight, returnFlight) ||
    0

  const totalAllotmentCount = economyClassAllotment + smartClassAllotment

  // Handle too many rows in the CSV
  if (amountOfUploadedPassengers > totalAllotmentCount) {
    const error = buildGenericNotification(getLabels('csv_has_to_many_rows'))

    dispatch(addNotification(error))
    return
  }

  // Handle rows in the CSV
  const sortedPassengers = sortArray(action.passengers, 'bookingId')

  const formatPassenger = (passenger: ServerUploadedPassengerInterface) =>
    morphism<
      StrictSchema<ClientPassengerInterface, ServerUploadedPassengerInterface>
    >(uploadedPassengerToPassengerSchema, passenger)

  const formattedPassengers: ClientPassengerInterface[] = sortedPassengers.map(
    formatPassenger
  )

  dispatch(addUploadedPassengers(formattedPassengers))
}
